<template>
    <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* nprogress进度条颜色修改 */
#nprogress .bar { background: #ccc !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue